<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.toolMagazine.form.specOption')">
                <a-select
                  v-model="queryParam.specOptionId"
                  allow-clear
                  show-search
                  :placeholder="$t('views.toolMagazine.form.specOptionPlaceholder')"
                  :loading="specOptionLoading"
                  option-filter-prop="_label"
                  option-label-prop="_label"
                  :filter-option="filterSpecOptionOption"
                  style="width: 100%"
                  :getPopupContainer="trigger => trigger.parentNode"
                  @dropdownVisibleChange="onSpecOptionDropdownVisible"
                >
                  <a-select-option
                    v-for="opt in specOptionOptions"
                    :key="opt.id"
                    :value="String(opt.id)"
                    :_label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.toolMagazine.column.name')">
                <a-input v-model="queryParam.name" :placeholder="$t('views.toolMagazine.query.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.toolMagazine.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.toolMagazine.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.form.width')">-->
<!--                <a-input v-model="queryParam.width" :placeholder="$t('views.toolMagazine.form.widthPlaceholder')" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.form.height')">-->
<!--                <a-input v-model="queryParam.height" :placeholder="$t('views.toolMagazine.form.heightPlaceholder')" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.form.borderDefense')">-->
<!--                <a-input v-model="queryParam.borderDefense" :placeholder="$t('views.toolMagazine.form.borderDefensePlaceholder')" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.form.quantity')">-->
<!--                <a-input v-model="queryParam.quantity" :placeholder="$t('views.toolMagazine.form.quantityPlaceholder')" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.column.productionTime')">-->
<!--                <a-date-picker style="width: 100%" v-model="queryParam.productionTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item :label="$t('views.toolMagazine.column.sort')">-->
<!--                <a-input v-model="queryParam.sort" :placeholder="$t('views.toolMagazine.query.sortPlaceholder')" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:toolMagazine:add']">
          <a-icon type="plus" />{{ $t('views.toolMagazine.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:toolMagazine:edit']">
          <a-icon type="edit" />{{ $t('views.toolMagazine.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:toolMagazine:remove']">
          <a-icon type="delete" />{{ $t('views.toolMagazine.btn.delete') }}
        </a-button>
        <a-button type="primary" @click="$refs.importExcel.importExcelHandleOpen()" v-hasPermi="['user:toolMagazine:import']">
          <a-icon type="upload" />{{ $t('views.toolMagazine.btn.import') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <import-excel ref="importExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="productionTime" slot-scope="text, record">
          {{ parseTime(record.productionTime) }}
        </span>
        <span slot="specOptionName" slot-scope="text, record">
          {{ text || record.specOptionId || '-' }}
        </span>
        <!-- 表格排序列已注释
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        -->
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <!-- 创建时间列已注释
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        -->
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:toolMagazine:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:toolMagazine:edit']">
            <a-icon type="edit" />{{ $t('views.toolMagazine.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:toolMagazine:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:toolMagazine:remove']">
            <a-icon type="delete" />{{ $t('views.toolMagazine.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageToolMagazine,listToolMagazine, delToolMagazine, updateToolMagazine } from '@/api/user/toolMagazine'
import { listSpecOption } from '@/api/user/specOption'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

/** 与 CreateForm 中规格选项下拉数据源一致 */
const TOOL_MAGAZINE_SPEC_ID = '647457401989140481'

export default {
  name: 'ToolMagazine',
  components: {
    CreateForm,
    ImportExcel
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      specOptionOptions: [],
      specOptionLoading: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        specOptionId: null,
        name: null,
        nameEn: null,
        width: null,
        height: null,
        borderDefense: null,
        quantity: null,
        productionTime: null,
        sort: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格选项',
          dataIndex: 'specOptionName',
          scopedSlots: { customRender: 'specOptionName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '名称(英文)',
          dataIndex: 'nameEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '宽度(mm)',
          dataIndex: 'width',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '高度(mm)',
          dataIndex: 'height',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '边封(mm)',
          dataIndex: 'borderDefense',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '数量(个)',
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '制作时间',
          dataIndex: 'productionTime',
          scopedSlots: { customRender: 'productionTime' },
          ellipsis: true,
          align: 'center'
        },
        // 表格排序列已注释
        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   scopedSlots: { customRender: 'sort' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        // 创建时间列已注释
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.updateColumnTitles()
    this.loadSpecOptionOptions()
    this.getList()
  },
  computed: {
    paginationShowTotal () {
      return total => this.$t('views.toolMagazine.pagination.total', { total })
    },
    /** 与行内编辑、updateToolMagazine 一致：user:toolMagazine:edit */
    canEdit () {
      return auth.hasPermi('user:toolMagazine:edit')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.updateColumnTitles()
    }
  },
  methods: {
    updateColumnTitles () {
      const m = {
        id: 'views.toolMagazine.column.id',
        specOptionName: 'views.toolMagazine.column.specOptionName',
        name: 'views.toolMagazine.column.name',
        nameEn: 'views.toolMagazine.column.nameEn',
        width: 'views.toolMagazine.column.width',
        height: 'views.toolMagazine.column.height',
        borderDefense: 'views.toolMagazine.column.borderDefense',
        quantity: 'views.toolMagazine.column.quantity',
        productionTime: 'views.toolMagazine.column.productionTime',
        // sort: 'views.toolMagazine.column.sort',
        status: 'views.toolMagazine.column.status',
        // createTime: 'views.toolMagazine.column.createTime',
        operation: 'views.toolMagazine.column.operation'
      }
      this.columns.forEach(col => {
        const key = m[col.dataIndex]
        if (key) {
          col.title = this.$t(key)
        }
      })
    },
    loadSpecOptionOptions () {
      if (this.specOptionLoading) {
        return
      }
      this.specOptionLoading = true
      listSpecOption({ specId: TOOL_MAGAZINE_SPEC_ID, parentId: 0 }).then(res => {
        const data = (res && res.data) || []
        this.specOptionOptions = Array.isArray(data) ? data : []
      }).finally(() => {
        this.specOptionLoading = false
      })
    },
    onSpecOptionDropdownVisible (open) {
      if (open && !this.specOptionOptions.length && !this.specOptionLoading) {
        this.loadSpecOptionOptions()
      }
    },
    filterSpecOptionOption (input, option) {
      const text =
        option &&
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      return (text || '').toLowerCase().includes((input || '').toLowerCase())
    },
    /** 查询刀库列表 */
    getList () {
      this.loading = true
     pageToolMagazine(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        specOptionId: undefined,
        name: undefined,
        nameEn: undefined,
        width: undefined,
        height: undefined,
        borderDefense: undefined,
        quantity: undefined,
        productionTime: undefined,
        sort: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      const idsText = Array.isArray(ids) ? ids.join(',') : String(ids)
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.toolMagazine.confirm.deleteTitle'),
        content: this.$t('views.toolMagazine.confirm.deleteContent', { ids: idsText }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delToolMagazine(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.toolMagazine.msg.deleteOk'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/tool-magazine/export', {
            ...that.queryParam
          }, `刀库_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateToolMagazine(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.toolMagazine.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.toolMagazine.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (!this.canEdit) {
        return
      }
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateToolMagazine(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.toolMagazine.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.toolMagazine.msg.sortFail'))
      })
    }
  }
}
</script>
